import { Component, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'vb-lxp-header',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './vb-lxp-header.component.html',
	styleUrl: './vb-lxp-header.component.css',
	encapsulation: ViewEncapsulation.None,
})
export class VbLxpHeaderComponent {
	// Center header
	centerImageSrc = input<string>('');
	centerImageAlt = input<string>('Logo');
	centerText = input<string>('');
	logoLink = input<string>('');
	logoLinkTarget = input<string>('_self');
	accentBar = input<boolean>(false);

	// Left side header (optional)
	eventTitle = input<string>('');
	eventSubtitle = input<string>('');
	elapsedTime = input<string>('');
	remainingTime = input<string>('');
	showLiveIndicator = input<boolean>(false);
}
